import useMutationExhibitionCreateUpdate from "./exhibition-use-mutation-create-update";
import useMutationExhibitionDelete from "./exhibition-use-mutation-delete";
import useMutationExhibitionRemove from "./exhibition-use-mutation-remove";

export const exhibitionUseMutation = {
  createUpdate: useMutationExhibitionCreateUpdate,
  remove: useMutationExhibitionRemove,
  delete: useMutationExhibitionDelete,
};
